import Translation from 'src/models/shared/interfaces/Translation'
import { Locales } from 'src/i18n'

export default class DynamicTranslation implements Translation {
  locale: Locales
  label: string

  constructor(locale: Locales, label: string) {
    this.locale = locale
    this.label = label
  }
}
